import React, { useEffect } from 'react';
import { useLanguage } from '../contexts/LanguageContext';
import Navigation from './Navigation';
import HeroSection from './HeroSection';
import ValueProposition from './ValueProposition';
import FeaturesSection from './FeaturesSection';
import HowItWorksSection from './HowItWorksSection';
import TestimonialsSection from './TestimonialsSection';
import CTASection from './CTASection';
import Footer from './Footer';

const LandingPage = () => {
  const { isRTL } = useLanguage();
  // Animation on scroll
  useEffect(() => {
    const animateOnScroll = () => {
      const elements = document.querySelectorAll('.staggered-animation');
      
      elements.forEach((element) => {
        const elementPosition = element.getBoundingClientRect().top;
        const screenPosition = window.innerHeight / 1.2;
        
        if (elementPosition < screenPosition) {
          element.classList.add('animate');
        }
      });
    };

    window.addEventListener('scroll', animateOnScroll);
    animateOnScroll(); // Run once on mount

    return () => {
      window.removeEventListener('scroll', animateOnScroll);
    };
  }, []);

  return (
    <div className={`font-sans antialiased text-gray-800 bg-white ${isRTL ? 'rtl' : 'ltr'}`}>
      <Navigation />

      <HeroSection />

      <TestimonialsSection />

      <ValueProposition />

      <FeaturesSection />

      <HowItWorksSection />

      <CTASection />
      
      <Footer />
    </div>
  );
};

export default LandingPage;
